module.exports = __webpack_public_path__ + "media/checkout_application_v3/assets/images/flag_it_italian-febcc1b18059405d2a1b169a335888f5.svg";